var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 1.66699H5.25008C2.33341 1.66699 1.16675 2.83366 1.16675 5.75033V9.25033C1.16675 12.167 2.33341 13.3337 5.25008 13.3337H8.75008C11.6667 13.3337 12.8334 12.167 12.8334 9.25033V8.08366",
    stroke: "#68616D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3566 2.26206L4.75993 6.85872C4.58493 7.03372 4.40993 7.37789 4.37493 7.62872L4.1241 9.38456C4.03076 10.0204 4.47993 10.4637 5.11576 10.3762L6.8716 10.1254C7.1166 10.0904 7.46076 9.91539 7.6416 9.74039L12.2383 5.14372C13.0316 4.35039 13.4049 3.42872 12.2383 2.26206C11.0716 1.09539 10.1499 1.46872 9.3566 2.26206Z",
    stroke: "#68616D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69751 2.9209C9.08834 4.31506 10.1792 5.4059 11.5792 5.80256",
    stroke: "#68616D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4674043f810e754e6abf88707bce5bb2.svg";
export { ForwardRef as ReactComponent };